import Block from './Block'
import store from '../util/store'

export default class HoverCards extends Block {
  getElems() {
    this.cards = Array.from(this.el.querySelectorAll('.b-hover-cards__card'))
    this.cursor = store.cursor
  }

  init() {
    if (store.detect.isMobile) return

    this.cards.forEach((card) => {
      card.querySelector('.b-hover-cards__card__content').style.transform = `translateY(${card.querySelector('p').offsetHeight * 100 / 1512 + 3200 / 1512}vw)`
    })
  }

  events() {
    if (store.detect.isMobile) return

    this.cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        card.querySelector('p').style.opacity = 1
        card.querySelector('.b-hover-cards__card__content').style.transform = 'translateY(0vw)'

        this.cursor.addState('-xl -white-full')
        this.cursor.setIcon('resources--assets--images--svg--arrow-external-big')
      })

      card.addEventListener('mouseleave', () => {
        card.querySelector('p').style.opacity = 0
        card.querySelector('.b-hover-cards__card__content').style.transform = `translateY(${card.querySelector('p').offsetHeight * 100 / 1512 + 3200 / 1512 + 'vw'})`

        this.cursor.removeState('-xl -white-full')
        this.cursor.removeIcon()
      })
    })
  }
}
